import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import {
  GetSideBarQuery,
  SidebarData,
} from '@hud/portal-dtos/webapp-common.dto';
import { PORTAL_BASE } from '../consts';

export const SIDEBAR_ID = 'sidebar';

export default function useSidebarQuery(query: GetSideBarQuery) {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [SIDEBAR_ID, query],
    queryFn: async () => {
      const response = await client.get<SidebarData>(`${PORTAL_BASE}/sidebar`, {
        params: query,
      });
      return SidebarData.parse(response.data);
    },
    enabled: isReady,
  });
}
